export function priceFormatter(input: number | string | null): string {
  if (!input) return '0 ₽';
  // Преобразуем входные данные в число
  const num = typeof input === 'string' ? parseFloat(input) : input;

  // Проверяем, является ли число валидным
  if (isNaN(num)) {
    throw new Error('Invalid number');
  }

  // Форматируем число
  const formattedNumber =
    num < 1000
      ? num.toString()
      : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Добавляем знак рубля
  return `${formattedNumber}\u00A0₽`;
}
